export default __webpack_public_path__ + "static/media/7.fd75d400.png";